import { useMemo } from 'react';

import { useShareToken } from '@/features/admin-interview';

export const useCandidateLink = (
  interviewId: string,
  candidateId: string
): string => {
  const shareToken = useShareToken();

  return useMemo(() => {
    const baseLink = `/interviews/${interviewId}/candidates/${candidateId}`;
    return shareToken ? `${baseLink}?token=${shareToken}` : baseLink;
  }, [candidateId, interviewId, shareToken]);
};
